<div class="lpa-events-submenu">
  <div class="submenu-header">
    <div class="header-content">
      <div class="header-icon">
        <i class="pi pi-calendar"></i>
      </div>
      <div class="header-text">
        <h2 class="section-title">Gestión de Eventos</h2>
        <p class="section-description">Administra competiciones, torneos y eventos deportivos de la Liga</p>
      </div>
    </div>
  </div>
  
  <div class="menu-grid">
    <div 
      class="menu-card" 
      [routerLink]="option.routerLink" 
      *ngFor="let option of menuItems"
      [attr.data-title]="option.title"
    >
      <div class="card-icon">
        <i [class]="option.class.replace('text-4xl text-green-500', '')"></i>
      </div>
      <div class="card-content">
        <h3 class="card-title">{{ option.title }}</h3>
        <p class="card-description">{{ option.description }}</p>
      </div>
      <div class="card-arrow">
        <i class="pi pi-arrow-right"></i>
      </div>
    </div>
  </div>
</div>